import Vue from 'vue'
import Vuex from 'vuex'
import { firestoreAction } from 'vuexfire'
import { db ,fb } from '@/db'
import { vuexfireMutations } from 'vuexfire'
Vue.use(Vuex)

export default new Vuex.Store({

  state: {
    DialogMsg :'',
    DialogState : false,
    user : null,
    userType : null,
    PortalFiles : null,
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg',
    drawer: null,
    Item:[],
    MenuItem :[],
    Users : [],
    Suppliers:[],
    Categories:[],
    CompanyInfo : [] ,
    Comments : [],
    Invoice:[],
    Units :[],
  },
  mutations: {
     ...vuexfireMutations,
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
   Set_User(state , user) {
    state.user = user
  },
  Set_UserType(state , type){
    state.userType = type
  },
  Set_DialogState(state , DialogState){
    state.DialogState = DialogState
  },
  Set_DialogMsg(state , Msg){
    state.DialogMsg = Msg
  },
  logout(state) {
    state.user = null
    },
  },

  getters:{
        isAuthentication(){
          return user
        }
  },

  actions: {

      getUser(){
        return user
      },

      setAuthUser(_, {username }){
        commit('setAuthUser1',username)
      },
        signout({commit}){
          return firebase.auth().signOut()
            .then(_ => commit('setAuthUser',null))
      },
      bindrequest: firestoreAction(({ bindFirestoreRef } ,  user ) => {
      if (user.userRole == 'admin'){
      return bindFirestoreRef('Item', db.collection('Requests'))
      }
      else{
        return bindFirestoreRef('Item', db.collection('Requests').where('user' , '==', user.user ))
      }
      })
      ,   
      bindMenu: firestoreAction(({ bindFirestoreRef } ,  Categories ) => {
      debugger
      return bindFirestoreRef('MenuItem', db.collection('Items').doc('MainItem').collection('Material').where('type' , '==', Categories.Category_Name ))
      
      }),
      binduser: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Users', db.collection('Users'))
      }),   
      bindSupplier: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Suppliers', db.collection('Supplier'))
      }),   
      bindComments: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Comments', db.collection('Comments'))
      }),   
      bindInvoice: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Invoice', db.collection('Purchase_Invoice'))
      }), 
      bindCategories: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Categories', db.collection('Categories'))
      }),   
      bindUnits: firestoreAction(({ bindFirestoreRef } ) => {
      return bindFirestoreRef('Units', db.collection('Units'))
      }),   
      bindportal: firestoreAction(({ bindFirestoreRef } ) => {
        return bindFirestoreRef('PortalFiles', db.collection('Portal'))
      }), 
  }
    
})
